import { useState } from 'react';
import Button from 'Components/Atoms/Button/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function NoProducts(props) {
    const { onClearConnection, onClose } = props;
    const [processing, setProcessing] = useState(false);

    const { t } = useTranslation('providers');

    const handleClick = async () => {
        setProcessing(true);
        await onClearConnection();
        onClose();
        setProcessing(false);
    };

    return (
        <div className="text-center">
            <div className="flex justify-center mb-6">
                <img src="/img/icon-error.svg" alt="" />
            </div>
            <h3 className="font-medium">{t('no-products-title')}</h3>
            <div className="mt-2 text-gray-500">{t('no-products-description')}</div>
            <div className="mt-6">
                <Button variant="primary" onClick={handleClick} isBusy={processing}>
                    {t('close')}
                </Button>
            </div>
        </div>
    );
}

NoProducts.propTypes = {
    onClearConnection: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
